import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'
import { useHistory } from 'react-router-dom'

const PurgeOrder = ({ order }) => {
  const history = useHistory()
  const { formatMessage } = useIntl()

  const purgeOrder = () => {
    if (confirm(`Are you sure you want to delete this Order (${order.name})`)) {
      fetch(`/rest/v2/order/${order.uid}`, { method: "DELETE" })
        .then((response) => {
          response.json()
        })
        .then(() => {
          toastr.success("Order deleted")
          history.push(`/dashboard`)
        })
    }
  }

  return (
    <Menu.Item state="negative">
      {(props) => (
        <MenuButton history={history} {...props} onClick={purgeOrder}>
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default PurgeOrder
